import React, { useState, useEffect } from 'react'
import { Alert, Box, TextField, Button, TableContainer, Table, TableHead, TableCell, TableRow, Paper, TableBody, Select, MenuItem, FormControl, CircularProgress } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { downloadDocument, getPropaneRefill, postPropaneRefill } from '../../../../../actions/tigercat-burns/tigercat-actions';
import { v4 as uuidv4 } from 'uuid';

const IgnitionFuel = ({ projectId, project }) => {
    const [propaneRefillState, setPropaneRefillState] = useState([])
    const dispatch = useDispatch()
    const propaneRefills = useSelector(state => state.tigercatBurnsReducer.propaneRefills.data)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(false)
    useEffect(() => {
        dispatch(getPropaneRefill(projectId));
    }, [dispatch, projectId]);

    useEffect(() => {
        const formDataArray = propaneRefills?.map((item) => {
            const formData = new FormData();
            formData.append('id', item.id);
            formData.append('date', item.date);
            formData.append('fuelType', item.fuelType);
            formData.append('refillVolume', item.refillVolume);
            formData.append('sourceDocument', item.sourceDocumentUrl);
            formData.append('disabled', true)
            return formData;
        });
        setPropaneRefillState(formDataArray);
    }, [propaneRefills]);

    const handleAddItem = () => {
        setPropaneRefillState((prevState) => {
            const state = [...prevState]
            const formData = new FormData();
            formData.append('id', null);
            formData.append('date', null);
            formData.append('fuelType', 'Propane');
            formData.append('refillVolume', null);
            formData.append('sourceDocument', null);
            formData.append('rowId', uuidv4())
            state.push(formData)
            return state
        })
    }

    const handleDateSelection = (date, dataId) => {
        setPropaneRefillState((prevState) => {
            return prevState.map((item) => {
                if (item.get('rowId') === dataId) {
                    const formattedDate = moment(date).format('YYYY-MM-DD');
                    item.set('date', formattedDate);
                }
                return item;
            });
        });
    }

    const handleFuelTypeChange = (e, dataId) => {
        setPropaneRefillState((prevState) => {
            return prevState.map((item) => {
                if (item.get('rowId') === dataId) {
                    item.set('fuelType', e.target.value);
                }
                return item;
            });
        });
    }

    const handleVolumeDeliveredChange = (e, dataId) => {
        setPropaneRefillState((prevState) => {
            return prevState.map((item) => {
                if (item.get('rowId') === dataId) {
                    item.set('refillVolume', e.target.value);
                }
                return item;
            });
        });
    }

    const handleSourceDoc = (e, dataId) => {
        const file = e.target.files[0];
        setPropaneRefillState((prevState) => {
            return prevState.map((item) => {
                if (item.get('id') === dataId) {
                    item.set('sourceDocument', file);
                }
                return item;
            });
        });
    }

    const fuelTypes = [
        { id: 0, name: 'Propane' }
    ]

    const handleSubmitData = () => {
        setLoading(true)
        setLoading(true)
        let hasError = false
        propaneRefillState.forEach((i) => {
            if (i.get('date') === 'null' || i.get('fuelType') === 'null' || i.get('refillVolume') === 'null') {
                setError(true)
                hasError = true
                return
            }
        })
        if (!hasError) {
            dispatch(postPropaneRefill(projectId, propaneRefillState)).then(() => {
                dispatch(getPropaneRefill(projectId))
                setLoading(false)
            })
        } else {
            setLoading(false)
        }
    }

    const handleDownload = async () => {
        try {
            dispatch(downloadDocument(projectId, 'ignition_fuel')).then((response) => {

                // Create a downloadable link for the Excel file
                const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${project}_ignition_fuel.xlsx`); // Set the file name
                document.body.appendChild(link);
                link.click();
                link.remove();
            })

        } catch (err) {
            console.error('Error downloading Equipment Transport:', err);
        }
    };

    return (
        <>
            <h2>Ignition Fuel </h2>
            <TableContainer key={0} component={Paper} >
                <Button variant='contained' sx={{ height: 'auto', float: 'right', mt: 2, mb: 2 }} onClick={handleDownload}>Download Excel</Button>
                <Table aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell size="small" align="left">
                                Date
                            </TableCell>
                            <TableCell size="small" align="left">
                                Fuel Type (ff)
                            </TableCell>
                            <TableCell size="small" align="left">
                                Refill Volume (gal)
                            </TableCell>
                            <TableCell size="small" align="left">
                                Source document
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {propaneRefillState?.map((data, index) => {
                            const sourceDocument = data.get('sourceDocument');
                            const isString = typeof sourceDocument === 'string' && sourceDocument !== 'null';
                            return (

                                <TableRow key={index}>
                                    <TableCell size="small" align="left">
                                        <FormControl>
                                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                                <DatePicker
                                                    slotProps={{
                                                        textField: {
                                                            error: false,
                                                        }
                                                    }}
                                                    name={'date'}
                                                    value={data.get('date') ? moment(data.get('date'), 'YYYYMMDD') : null}
                                                    onChange={(e) => handleDateSelection(e._d, data.get('rowId'))}
                                                    disabled={data.get('disabled') ?? false}
                                                    format="MM/DD/YYYY"
                                                />
                                            </LocalizationProvider>
                                        </FormControl>
                                    </TableCell>
                                    <TableCell size="small" align="left">
                                        <Select name='fuel type' value={data.get('fuelType')} disabled={true} fullWidth onChange={(e) => handleFuelTypeChange(e, data.get('rowId'))}>
                                            {fuelTypes?.map(type => {
                                                return (
                                                    <MenuItem key={type.id} value={type.name} >
                                                        {type.name}
                                                    </MenuItem>
                                                );
                                            })}
                                        </Select>
                                    </TableCell>
                                    <TableCell size="small" align="left">
                                        <TextField
                                            name='fuel volume delivered'
                                            value={JSON.parse(data.get('refillVolume')) === null ? '' : data.get('refillVolume')}
                                            onChange={(e) => handleVolumeDeliveredChange(e, data.get('rowId'))}
                                            type="text"
                                            disabled={data.get('disabled') ?? false}

                                        />
                                    </TableCell>
                                    <TableCell size="small" align="left">
                                        {isString ? (
                                            <a href={sourceDocument} target="_blank" rel="noopener noreferrer">
                                                Document
                                            </a>
                                        ) : (
                                            <TextField
                                                name={'Lab results'}
                                                defaultValue={sourceDocument && sourceDocument.name ? sourceDocument.name : ''}
                                                onChange={(e) => handleSourceDoc(e, data.get('rowId'))}
                                                type="file"
                                            />
                                        )}
                                    </TableCell>
                                </TableRow>
                            )
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
            {error ? <Alert severity='error' sx={{ my: 2 }}>Please fill out all fields before submitting</Alert> : null}
            <Box sx={{ position: 'relative', mb: 10 }}>
                <Button variant='contained' sx={{ height: 'auto', mt: 2 }} onClick={handleAddItem}>Add Entry</Button>
                {loading ? <CircularProgress sx={{ position: 'absolute', left: '125px', top: '12px' }}></CircularProgress> : <Button variant='contained' sx={{ height: 'auto', mt: 2, ml: 3 }} onClick={handleSubmitData}>Submit Data</Button>}
                {loading && <Alert severity='info' sx={{ my: 2 }}>Please be patient during data submission as file uploads can take some time to complete</Alert>}
            </Box>
        </>
    )
}

export default IgnitionFuel